import { AtsFeedbackDetailFragment, AtsFeedbackVisibilityEnum } from 'generated/resources/graphql'

import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useDeleteFeedback } from 'modules/ats/hooks/feedbacks/useDeleteFeedback'

const isValidVisibility = (
  value: string | null | undefined
): value is AtsFeedbackVisibilityEnum => {
  return value === 'public' || value === 'restricted'
}

export const toVisibilityEnum = (value: string | null | undefined): AtsFeedbackVisibilityEnum => {
  return isValidVisibility(value) ? value : 'public'
}

export interface AtsFeedbackFormValues {
  description: string | null | undefined
  rating: number | null | undefined
  atsCandidateId: number
  atsApplicationId: number | null | undefined
  atsApplicationPhaseId: number | null | undefined
  attachments: File[]
  mentionIds: number[] | null
  visibility: AtsFeedbackVisibilityEnum
}

export const useOnFeedbackDelete = (feedback: AtsFeedbackDetailFragment) => {
  const { loading: isDeleting, deleteFeedback } = useDeleteFeedback(feedback)

  const onFeedbackDelete = async () => {
    const handled = handleResult(await deleteFeedback(), () => undefined)

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.removed_successfully'),
      })
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('common.removed_failed'),
      })
    }
  }

  return {
    onFeedbackDelete,
    isDeleting,
  }
}
